import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../api";


export const getDataBanner = createAsyncThunk("market/getDataBanner", async (_, thunkAPI) => {
  const { rejectWithValue } = thunkAPI;
  try {
    const response = await api.get("/api/Marketings/headSection");
    return response.data;
  } catch (error) {
    return rejectWithValue(error.message);
  }
});

export const getDataMap = createAsyncThunk("market/getDataMap", async (_, thunkAPI) => {
  const { rejectWithValue } = thunkAPI;
  try {
    const response = await api.get("/api/Marketings/countries");
    return response.data;
  } catch (error) {
    return rejectWithValue(error.message);
  }
});

export const getDataMapDesc = createAsyncThunk("market/getDataMapDesc", async (_, thunkAPI) => {
  const { rejectWithValue } = thunkAPI;
  try {
    const response = await api.get("/api/Marketings/textSection");
    return response.data;
  } catch (error) {
    return rejectWithValue(error.message);
  }
});

const initialState = {
  banner: [],
  map: [],
  desc: [],
  isLoading: false,
  error: null,
};

export const marketSlice = createSlice({
  name: "market",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(getDataBanner.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getDataBanner.fulfilled, (state, action) => {
        state.isLoading = false;
        state.banner = action.payload;
      })
      .addCase(getDataBanner.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(getDataMap.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getDataMap.fulfilled, (state, action) => {
        state.isLoading = false;
        state.map = action.payload;
      })
      .addCase(getDataMap.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(getDataMapDesc.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getDataMapDesc.fulfilled, (state, action) => {
        state.isLoading = false;
        state.mapDesc = action.payload;
      })
      .addCase(getDataMapDesc.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
  },
});

export default marketSlice.reducer;
